import React, { useState, useEffect } from 'react';

import './styles.css';

const Toast = ({ text, classNames = '', isVisible, msDelay = 1000, onClose, type }) => {
  const [opacity, setOpacity] = useState({ opacity: 1 });

  useEffect(() => {
    if (isVisible === true) {
      setTimeout(() => {
        setOpacity({ opacity: 0 });
      }, msDelay);

      if (onClose) {
        setTimeout(onClose, msDelay + 1000);
      }
    }
  }, [isVisible]);

  return (
    <div className={`toast-react ${type}`} style={opacity}>
      {type === 'error' || type === 'warning' ? <i className='hr-Alert' /> : <i className='hr-Checkmark' />}
      {text}
    </div>
  );
};

export default Toast;
